import { initAxiosRH, loadAbort } from "#api/axios.service"
const axios=initAxiosRH()

const LOAN="talent_cloud/loan"
const LOAN_ID=(id)=>`${LOAN}/${id}`
const LOAN_METHOD_PAY=`${LOAN}/method_pay`


export const loanGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(LOAN,{params,signal:controller.signal})
    return {call,controller}
}
export const loanIdGet = ({id ,params}) => {
    const controller= loadAbort()
    const call= axios.get(LOAN_ID(id),{params,signal:controller.signal})
    return {call,controller}
}

export const loanMethodPayGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(LOAN_METHOD_PAY,{params,signal:controller.signal})
    return {call,controller}
}


export const loanIdPut = (id,data,params) => {
const controller= loadAbort()
const call= axios.put(LOAN_ID(id),data,{params,signal:controller.signal})
return {call,controller}
}
